// extracted by mini-css-extract-plugin
module.exports = {"content":"styles-module__content___k1SA4"};